/* Global page functions */
var $ = require('jquery');
var M = require("./vendors/materialize");

var Global = function () {
    'use strict';

    this.setSearchPlaceholder = function (placeholder, isMain) {

        let cseSearch = document.getElementById("search-preview");
        if (cseSearch !== undefined && cseSearch !== null){
            
            cseSearch.addEventListener("mouseover", function( event ) {
                if (cseSearch.style.display !== 'none'){
                    cseSearch.style.display = 'none';
                    var body = document.getElementsByTagName('body')[0];
                    var script = document.createElement("script");
                        script.async=true,
                        script.src="https://cse.google.com/cse.js?cx="+(isMain?"000003788788723950888:qnps96dtily": "000003788788723950888:qwjfi4k1kne"),
                        script.onload = function() {
                            setTimeout(function() {
                                $(".gsc-control-cse, .gsc-search-button-v2, .gsc-search-button-v2:hover, .gsc-search-button-v2:focus").attr("style", "border-color: transparent !important;background-color: transparent !important;");
                                $(".gsc-input").attr("placeholder", placeholder);
                                $(".gsc-input").attr("style", "height: 36px;");
                                $(".gsc-input-box").attr("style", "border:none; !important");
                                $(".gsc-search-button svg").attr("width", "30").attr("height", "30");
                                $(".gsc-search-button").attr("style", "padding: 0px;");
                                $(".gsc-search-box tr").attr("style", "border: none;");
                                $(".navig-container").attr("style", "padding-bottom: 24px");
                            }, 500);
                        };                        
                    (typeof body === 'undefined' ? document.getElementsByTagName('html')[0] : body).appendChild(script);
                }
            }, false);
            
        }
    };
    
    // Offcanvas
    this.offcanvasMenu = function () {
        $('body').prepend('<a href="#"  data-target="slide-out" class="sidenav-trigger fc-nav-toggle"><span></span></a>');
        $('body').prepend('<ul id="slide-out" class="sidenav"> </ul>');

        $('#slide-out').append("<li>");
        $('#slide-out li').append($('#fc-header #fc-logo').clone());

        $('#slide-out').append("<li><div class='divider'></div></li>");

        /*Mobile site langs menu*/
        $('#slide-out').append("<li class='mobile-menu-langs'>");
        
        var langs = $("<ul style='display:none;'>");
        $('#sitelangs-dropdown li').each(function () {  
            var $this = $(this);            
            langs.append($this.clone());            
        });        

        $('#slide-out .mobile-menu-langs')
                .append("<div class='site-lang site-lang-btn-mobile'>" + $('.site-lang-btn-desktop'). text()+ "<div class='icon icon-down'></div></div>");
        $('#slide-out .mobile-menu-langs').append(langs);
        $('.site-lang-btn-mobile').click(function () {
            $('#slide-out .mobile-menu-langs ul').toggle();
           
            var icon = $('.mobile-menu-langs .site-lang-btn-mobile .icon');
            if ($(".site-lang-btn-mobile .icon-down").length > 0){ 
                icon.removeClass("icon-down")
                    .addClass("icon-up");
            } else {
                icon.removeClass("icon-up")
                    .addClass("icon-down");
            }
        });
        /* End of mobile site langs menu*/

        $('#slide-out').append("<li><div class='divider'></div></li>");
        
        $('.center-menu li').each(function () {
            var $this = $(this);            
            $('#slide-out').append($this.clone());            
        });

        var elems = document.querySelectorAll('.sidenav');
        var sidenav = M.Sidenav.init(elems);        

    };

    this.goToTop = function () {
        var offset = 300,  // browser window scroll (in pixels) after which the "back to top" link is shown
            offset_opacity = 1200,  //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
            scroll_top_duration = 700;  //duration of the top scrolling animation (in ms)
        var $back_to_top = $('.cd-top');  //grab the "back to top" link

        $(window).scroll(function () {

            ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');

            if ($(this).scrollTop() > offset_opacity) 
                $back_to_top.addClass('cd-fade-out');
        });

        $back_to_top.on('click', function (event) {

            event.preventDefault();

            $('body,html').animate({
                scrollTop: 0
            }, scroll_top_duration);

            return false;
        });

    };
    
    this.showGoToTop = function(isShow) {
        var $back_to_top = $('.cd-top');
        isShow? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
    };

    function getBrowserLocales(options = {}) {
        const defaultOptions = {
            languageCodeOnly: true
        };

        const opt = {
            ...defaultOptions,
            ...options
        };

        const browserLocales =
                navigator.languages === undefined
                ? [navigator.language]
                : navigator.languages;

        if (!browserLocales) {
            return undefined;
        }

        const langs =  browserLocales.map(locale => {
            const trimmedLocale = locale.trim();

            return opt.languageCodeOnly
                    ? trimmedLocale.split(/-|_/)[0]
                    : trimmedLocale;
                    
        });

        return langs.filter(function (item, pos, self) {
            return self.indexOf(item) === pos;
        })        
    }

     this.onMainThemeLoading = function() {
        this.offcanvasMenu();
        this.goToTop();
              
        $('.dropdown-trigger').dropdown();
 
        $('li[id^="select-options"]').on('touchend', function (e) {
           e.stopPropagation();
        });     
       
        $('#copyright-date').text((new Date()).getFullYear());       
        $("#alluserlangs").val(getBrowserLocales());

        if (Intl){
            $("#timeZone").val(Intl.DateTimeFormat().resolvedOptions().timeZone);
        }        
    };

/*
    this.YandexHitUrl = function (url, title, referer) {
        if (window.yaCounter44774446 != null)
            window.yaCounter44774446.hit(url, {title : title, referer: referer});

    };    
    
    this.changePageUrl = function (pageurl) {
        if (pageurl != window.location)
            window.history.pushState({path: pageurl}, '', pageurl);
        return false;
    };
*/
    this.setDownloadLink = function (link, href, download){
        link[0].href = href;
        link[0].download = download;
    };

    return this;
};


module.exports = Global;
